module.exports = __webpack_public_path__ + "static/media/Rectangle@2x.3beef072.png";